<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>新增代采组</div>
    </div>

    <el-row class="filter">
      <div
        style="
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="代采组" prop="pgname">
            <el-input v-model="form.pgname"></el-input>
          </el-form-item>
          <el-form-item label="代采组昵称" prop="pgnick">
            <el-input v-model="form.pgnick"></el-input>
          </el-form-item>
          <el-form-item label="代采组报单名" prop="pgbilling">
            <el-input v-model="form.pgbilling"></el-input>
          </el-form-item>
          <el-form-item label="城市" prop="city">
            <el-select v-model="form.city" filterable placeholder="城市">
              <el-option
                v-for="item in citys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否启用" prop="is_use">
            <el-select v-model="form.is_use" filterable placeholder="是否启用">
              <el-option
                v-for="item in isUse"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row> </el-row>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst";
export default {
  data() {
    return {
      resData: {},
      form: {
        pgname: "",
        pgnick: "",
        pgbilling: "",
        city: "",
        is_use: "",
      },
      citys: CITY,
      isUse: [
        {
          value: "1",
          label: "启用",
        },
        {
          value: "0",
          label: "禁用",
        },
      ],
      rules: {
        pgname: [
          {
            required: true,
            message: "请输入代采组名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "档口号最长可以输入20个字符",
            trigger: "blur",
          },
        ],
        pgnick: [
          {
            required: true,
            message: "请输入代采组昵称",
            trigger: "blur",
          },
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/PurchaseGroup/savePgInfo",
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  // beforeRouteEnter(to, from, next) {
  //     next(vm => {
  //         vm.fetchData();
  //     });
  // },
  methods: {
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    onSubmit() {
      if (this.form.is_use == 0) {
        this.$confirm(
          "新建商家是不能再绑定已禁用的代采组,确定禁用代采组?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.postHandle();
        });
      } else {
        this.postHandle();
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    postHandle() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message({
            type: 1,
            message: res.data.msg,
          });
          this.form = {};
          let m = Date.parse(new Date());
          this.$router.push("/home/purchase?type=group&time=" + m);
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/purchasegroup/AddPGroup.vue